import { render, staticRenderFns } from "./BiannualLevel.vue?vue&type=template&id=ce2a9be2&scoped=true"
import script from "./BiannualLevel.vue?vue&type=script&lang=js"
export * from "./BiannualLevel.vue?vue&type=script&lang=js"
import style0 from "./BiannualLevel.vue?vue&type=style&index=0&id=ce2a9be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2a9be2",
  null
  
)

export default component.exports